import firebase from 'firebase/app'
import {HTTP_API_V2} from '../../http-common'

export default {
  state: {
    loadedProperties: [],
    loadedPropertiesV2: []
  },
  getters: {
    loadedProperties (state) {
      return state.loadedProperties
    },
    loadedPropertiesV2 (state) {
      return state.loadedPropertiesV2
    },
    loadedProperty (state) {
      return (propertyId) => {
        return state.loadedProperties.find(property => {
          return property.id === propertyId
        })
      }
    },
    loadedPropertyV2 (state) {
      return (propertyId) => {
        return state.loadedPropertiesV2.find(property => {
          return property.id === propertyId
        })
      }
    }
  },
  // synchronous
  mutations: {
    setLoadedProperties (state, payload) {
      state.loadedProperties = payload
    },
    setLoadPropertiesV2 (state, payload) {
      state.loadedPropertiesV2 = payload
    },
    createProperty (state, payload) {
      state.loadedProperties.push(payload)
    },
    updateProperty (state, payload) {
      // state.loadedProperties = state.loadedProperties.map(property => property.id === payload.id ? payload : property)
      const property = state.loadedPropertiesV2.find(property => {
        return property.id === payload.id
      })
      if (payload.description) {
        property.description = payload.description
      }
      if (payload.nuclei) {
        property.nuclei = payload.nuclei
      }
    },
    removeProperty (state, payload) {
      let properties = state.loadedProperties.filter(property => {
        return property.id !== payload.id
      })
      state.loadedProperties = properties
    }
  },
  // asynchronous
  actions: {
    loadProperties ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/properties').once('value')
        .then(data => {
          let properties = []
          const obj = data.val()
          for (let key in obj) {
            properties.push({
              id: key,
              description: obj[key].description,
              nuclei: obj[key].nuclei
            })
          }
          commit('setLoadedProperties', properties)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    loadPropertiesV2 ({commit}) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadPropertiesV2', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('properties')
          .then(result => {
            const properties = result.data.map(property => {
              return {
                id: property.id,
                description: property.description,
                country: property.country,
                state: property.state,
                city: property.city,
                address: property.address,
                nuclei: property.nuclei
              }
            })
            commit('setLoadPropertiesV2', properties)
            resolve(properties)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err.message)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createProperty ({ commit, getters }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const newProperty = {
        description: payload.description,
        nuclei: payload.nuclei
      }
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/properties').push(newProperty)
        .then(data => {
          console.log(data)
          commit('createProperty', {
            ...newProperty
          })
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    updateProperty ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const updateObj = {}
      if (payload.description) {
        updateObj.description = payload.description
      }
      if (payload.nuclei) {
        updateObj.nuclei = payload.nuclei
      }
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/properties').child(payload.id).update(updateObj)
        .then(() => {
          commit('updateProperty', payload)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    removeProperty ({ commit }, payload) {
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/properties').child(payload.id).remove()
        .then(() => {
          commit('removeProperty', payload)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/property/index.js